import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";

export default {

    async criaItens(itensValores = []){

        let itens;

        try{

            //==================================================================//
            //=========================== Cria Itens ===========================//
            //==================================================================//

            itens = await ERP.postMany(Schema.REVISAO_JOB_ITENS, itensValores);
            if(itens.status != 200){
                throw itens;
            }

            console.log(itens);


        }catch(e){

            console.log(e);
            return itens;

        }

        return itens;

    },

}